import React from 'react';
import {
  Box,
  Chip,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import {
  Business as BusinessIcon,
  CalendarMonth as CalendarMonthIcon,
  MonetizationOn as MonetizationOnIcon,
  ReceiptLong as ReceiptLongIcon,
} from '@mui/icons-material';
import formatDate from './utils/formatDate';

const STATE_CONFIG = {
  CREADA: { label: 'CREADA', bg: '#90a4ae', color: '#fff' },
  EN_PROCESO: { label: 'EN PROCESO', bg: '#1976d2', color: '#fff' },
  EN_REVISION: { label: 'EN REVISIÓN', bg: '#f9a825', color: '#000' },
  APROBADA: { label: 'APROBADA', bg: '#2e7d32', color: '#fff' },
  FACTURADA: { label: 'FACTURADA', bg: '#6a1b9a', color: '#fff' },
  COBRADA: { label: 'COBRADA', bg: '#00695c', color: '#fff' },
  CANCELADA: { label: 'CANCELADA', bg: '#d32f2f', color: '#fff' },
};

/*const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(`${value}T00:00:00`);
  return new Intl.DateTimeFormat('es-PE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};*/

const ValuationHeaderCard = ({ valuation }) => {
  if (!valuation) return null;

  const state = STATE_CONFIG[valuation.valcabest] || {
    label: valuation.valcabest || 'SIN ESTADO',
    bg: '#bdbdbd',
    color: '#000',
  };

  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', md: 'center' }}
        flexDirection={{ xs: 'column', md: 'row' }}
        gap={2}
        mb={2}
      >
        <Box>
          <Typography variant="h5" fontWeight="bold" color="primary">
            VAL-{String(valuation.valcabid).padStart(6, '0')}
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={0.5}>
            Documento de valorización del proyecto seleccionado para el periodo indicado.
          </Typography>
        </Box>

        <Chip
          label={state.label}
          sx={{
            backgroundColor: state.bg,
            color: state.color,
            fontWeight: 'bold',
            minWidth: 130,
          }}
        />
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2.2}>
        <Grid item xs={12} md={4}>
          <Stack direction="row" spacing={1.2} alignItems="flex-start">
            <BusinessIcon color="primary" fontSize="small" />
            <Box>
              <Typography variant="body2" color="text.secondary">
                Proyecto
              </Typography>
              <Typography fontWeight="medium">
                {valuation.pronom || '-'}
              </Typography>
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={12} md={4}>
          <Stack direction="row" spacing={1.2} alignItems="flex-start">
            <MonetizationOnIcon color="primary" fontSize="small" />
            <Box>
              <Typography variant="body2" color="text.secondary">
                Moneda
              </Typography>
              <Typography fontWeight="medium">
                {valuation.moncod
                  ? `${valuation.moncod} - ${valuation.monnom || ''}`.trim()
                  : '-'}
              </Typography>
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={12} md={4}>
          <Stack direction="row" spacing={1.2} alignItems="flex-start">
            <CalendarMonthIcon color="primary" fontSize="small" />
            <Box>
              <Typography variant="body2" color="text.secondary">
                Periodo
              </Typography>
              <Typography fontWeight="medium">
                {formatDate(valuation.valcabfecini)} - {formatDate(valuation.valcabfecfin)}
              </Typography>
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={1.2} alignItems="flex-start">
            <ReceiptLongIcon color="primary" fontSize="small" />
            <Box>
              <Typography variant="body2" color="text.secondary">
                Descripción
              </Typography>
              <Typography>
                {valuation.valcabdes || 'Sin descripción registrada.'}
              </Typography>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ValuationHeaderCard;